// @flow
import { APICore } from './apiCore';

const api = new APICore();

function ApiGetAllDepartment(params: any): any {
    const baseUrl = '/api/admin/department';
    return api.get(`${baseUrl}`, params);
}
function ApiPostDepartment(params: any): any {
    const baseUrl = '/api/admin/department';
    // console.log('🚀 ~ ApiPostFasilitas ~ params:', params);
    return api.create(`${baseUrl}`, params);
}
function ApiEditDepartment(params: any, id: any): any {
    const baseUrl = '/api/admin/department/' + id;
    return api.update(`${baseUrl}`, params);
}

export {
    // ApiGetAllKategoriMenu,
    ApiGetAllDepartment,
    // ApiGetReportFasilitas,
    // ApiPostCategoryRoom,
    ApiPostDepartment,
    // ApiEditKategoriRoom,
    ApiEditDepartment,
    // ApiDeleteKategoriRoom,
};
